import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

const base = "group inline-flex items-center justify-center gap-2 font-semibold text-sm uppercase tracking-wider px-7 py-4 transition-colors duration-200 rounded-sm";

const variants = {
    primary: "bg-brand text-white hover:bg-brand-dark",
    light: "bg-white text-navy hover:bg-slate-100",
    outline: "border border-white/25 text-white hover:bg-white hover:text-navy",
    outlineNavy: "border border-navy/25 text-navy hover:bg-navy hover:text-white",
    ghost: "text-navy hover:text-brand",
};

export const CTAButton = ({ to, href, children, variant = "primary", arrow = true, className = "", ...props }) => {
    const cls = `${base} ${variants[variant]} ${className}`;
    const inner = (
        <>
            {children}
            {arrow && <ArrowUpRight weight="bold" className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" size={18} />}
        </>
    );
    if (to) return <Link to={to} className={cls} {...props}>{inner}</Link>;
    if (href) return <a href={href} className={cls} {...props}>{inner}</a>;
    return <button className={cls} {...props}>{inner}</button>;
};
